import parseQuestions from '../getCompliance/parseQuestions'

function parseResponse(response): ComplianceQuestion[] | undefined {
  if (response.error) {
    return undefined
  }

  return parseQuestions(response.questions)
}

export default parseResponse
